import Button from "../forms/Button";
import { Form } from "react-bootstrap";
import React from "react";
import { useSearchParams } from "react-router-dom";

const useCustomSearchParams = () => {
  const [search, setSearch] = useSearchParams();
  const searchAsObject = Object.fromEntries(
    new URLSearchParams(search)
  );
  return [searchAsObject, setSearch];
};

export default ({ children }) => {

  const [search, setSearch] = useCustomSearchParams();

  const handleFilter = () => {

    const formData = new FormData(document.getElementById("filter"));

    const data = [...formData.entries(),];

    const searchAsObject = Object.fromEntries(
      new URLSearchParams(data)
    );

    setSearch({ ...search, ...searchAsObject })

  };

  return (
    <Form
      onSubmit={(e) => {
        e.preventDefault();
      }}
      id="filter"
    >
      <input type="hidden" name="page" defaultValue={1} />
      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-3">
        {children}
      </div>
      <Button
        type="button"
        label="فیلتر"
        background="bg-black text-white text-lg my-2 mt-5 mb-5 px-8"
        onClick={handleFilter}
      />
    </Form>
  );
};
